
import { PageHeader } from '../PageHeader/PageHeader'
import about from './About.module.css'
import dp from './../../img/pic.jpg'

const About = () => {
    return (
        <div className={about.aboutMe} id='about'>
            <PageHeader title={'About Me'} />
            <div className={about.container}>
                <div className={about.text}>
                    <h2>Hi, I'm Syed Sadaqhuat Yaseen</h2>
                    <p>
                        I'm an aspiring Full Stack Web Developer.
                        Learning MERN Stack. I'm skilled in both Front-end and Back-end technologies.
                         I'm passionate about learning, creating new things and problem-solving.
                    </p>
                </div>
                <div className={about.photo}>
                    <img className={about.dp} src={dp} alt="propic" />
                </div>
            </div>
        </div>
    )
}

export {About}
